import Http from '@/api/http/';

export default class AiAudit extends Http {
  constructor() {
    super();
  }
  /**
   * 智能小测验
   * @param {string} taskDesc -  taskDesc
   */
  aiAudit_aiQuiz() {
    return super.post('aiAudit/aiQuiz', ...arguments);
  }

  /**
   * 错别字
   * @param {string} id -  string
   */
  aiAnalysis_analyzeErrorWords() {
    return super.post('aiAnalysis/analyzeErrorWords', ...arguments);
  }

  /**
   * 检测AI内容
   * @returns
   */
  aiAnalysis_checkWhetherAiContent() {
    return super.post('aiAnalysis/checkWhetherAiContent', ...arguments);
  }

  /**
   * AI解析Excel
   * @param {string} url - url
   */
  aiAnalysis_analyzeExcel() {
    return super.post('aiAnalysis/analyzeExcel', ...arguments);
  }

  /**
   * AI智能审核
   * @param {string} reportLogId - 报告id
   */
  aiAuditReport_getAuditResult() {
    return super.post('aiAuditReport/getAuditResult', ...arguments);
  }

  /**
   * AI审核报告头
   * @param {string} reportLogId - 报告id
   */
  aiAnalysis_aiAuditReportAttribute() {
    return super.post('aiAnalysis/aiAuditReportAttribute', ...arguments);
  }

  /**
   * AI审核报告考核点
   * @param {string} reportExperienceInfoId - 考核点id
   */
  aiAnalysis_aiAuditReportInfo() {
    return super.post('aiAnalysis/aiAuditReportInfo', ...arguments);
  }
}
